<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-27 13:17:49
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id='page_Container' class='infoClass'>
        <div class="page">
            <div id="main-container" class='main-container'>
                <div class="headImageSetting bgwhite">

                    <van-cell-group>
                        <van-cell title="头像：" is-link @click='addPhoto' class='addphoto'>
                            <div class='headerBox' v-bind:style="{backgroundImage:'url(' + headImageUrl + ')'}">

                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class='mt12 bgwhite'>
                    <van-cell-group>
                        <van-cell title="昵称：" is-link :value="accoutDetail.accountNickName" @click='changeName' />
                    </van-cell-group>
                </div>
                <div class='mt12 bgwhite'>
                    <van-cell-group>
                        <van-cell title="生日：" is-link :value="accoutDetail.birthday" @click='chooseDate' />
                    </van-cell-group>
                </div>
                <div class='mt12 bgwhite'>
                    <van-cell-group>
                        <van-cell title="性别：" is-link :value="accoutDetail.sex" @click='chooseSex' />
                    </van-cell-group>
                </div>
                <div class='mt12 bgwhite'>
                    <van-cell-group>
                        <van-field v-model="accoutDetail.mobileNumber" class='phone' label="手机号：" disabled />
                    </van-cell-group>
                </div>
                <div class='mt12 bgwhite' v-if="Number(merchantInfo.isSupportCis) === 1">
                    <van-cell-group>
                        <van-cell :value="accoutDetail.accountBind" title="账户绑定：" is-link @click='changeAccountBind'/>
                    </van-cell-group>
                </div>
                <div class='buttonStyle'>
                    <van-button type="default" @click='logout'>退出</van-button>
                </div>
                <van-popup v-model="dateShow" position="bottom" :overlay="false">
                    <van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm='confirmDate' @cancel='cancelDate' />
                </van-popup>
                <van-popup v-model="sexShow" position="bottom" :overlay="false">
                    <van-picker ref="sexPicker" :columns="sexColumns" :default-index="checkedSexIndex" @confirm='confirmSex' @cancel='cancelSex' show-toolbar/>
                </van-popup>
                <van-popup v-model="nameShow" position="right" class='nameShowStyle' :overlay="false">
                    <van-cell-group class='mt12 bgwhite'>
                        <van-field v-model="accoutDetail.accountNickName" label="昵称：" clearable placeholder="请输入昵称" />
                    </van-cell-group>
                    <div class='nameBox'>
                        <van-button type="default" @click='nameBtn' class='btnOk' round>确定</van-button>
                        <van-button type="default" @click='backBtn' class='btnCancel' round>返回</van-button>
                    </div>
                </van-popup>
                <van-popup v-model="accountBindShow" position="right" class='nameShowStyle' :overlay="false">
                    <van-cell-group class='mt12 bgwhite'>
                        <van-field v-model="accoutDetail.cisAccId" label="户号：" clearable placeholder="请输入户号" />
                        <van-field v-model="accoutDetail.cisEntityName" label="户名：" clearable placeholder="请输入户名" />
                    </van-cell-group>
                    <div class='nameBox'>
                        <van-button type="default" @click='accountBindBtn' class='btnOk' round>绑定</van-button>
                        <van-button type="default" @click='backBtn' class='btnCancel' round>返回</van-button>
                    </div>
                </van-popup>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading, hasEmoji, confirmModal } from '@/utils/base/utils';
import { mapGetters } from 'vuex';
// import { stringify } from 'querystring';

export default {
    components: {
        Toast
    },
    props: ['popShow'],
    data() {
        return {
            accountBindShow: false,
            headImageUrl: require('../assets/img/myCenter/defaultImg.png'),
            accoutDetail: {
                accountNickName: '',
                mobileNumber: '',
                birthday: '',
                sex: '',
                accountBind: '',
                accountAvatar: ''
            },
            emptyDetail: {},
            // 日期变量
            dateShow: false,
            currentDate: new Date(),
            maxDate: new Date(),
            minDate: new Date(1950, 10, 1),
            // 生日变量
            sexShow: false,
            nameShow: false,
            sexColumns: ['男', '女'],
            checkedSexIndex: 0,
            value: {}
            // merchantInfo: {}
        };
    },
    esvReady() {
        document.title = '个人信息';
        // this.getMerchantInfo();
    },
    esvShow() {
        this.accoutDetail = {
            accountNickName: '',
            mobileNumber: '',
            birthday: '',
            sex: '',
            accountBind: '',
            accountAvatar: ''
        };
        this.emptyDetail = { ...this.accoutDetail };
        this.queryMemberAccountDetail();
    },
    methods: {
        // getMerchantInfo() {
        //     this.ESVStorage.getSessionValue('merchantInfo', (merchantInfo) => {
        //         if (merchantInfo) {
        //             this.merchantInfo = merchantInfo;
        //         } else {
        //             this.$doRequest(
        //                 { url: '/merchant/getMerchantInfo', params: {} },
        //                 (data) => {
        //                     this.merchantInfo = data.result;
        //                     this.ESVStorage.putSessionValue('merchantInfo', this.merchantInfo);
        //                 }
        //             );
        //         }
        //     });
        // },
        changeAccountBind() {
            this.accountBindShow = true;
        },
        backBtn() {
            this.nameShow = false;
            this.accountBindShow = false;
            this.queryMemberAccountDetail();
        },
        accountBindBtn() {
            if (!this.accoutDetail.cisAccId.trim()) {
                Toast('cis会员id输入不能为空');
                return false;
            } else if (!this.accoutDetail.cisEntityName.trim()) {
                Toast('cis会员姓名输入不能为空');
                return false;
            }
            this.bindCisMemberAccount();
        },
        nameBtn() {
            if (this.accoutDetail.accountNickName.length <= 0) {
                Toast('昵称输入不能为空');
                return false;
            }
            if (this.accoutDetail.accountNickName.length > 40) {
                Toast('昵称长度不能超过 40 个字符哦~');
                return false;
            }
            if (hasEmoji(this.accoutDetail.accountNickName)) {
                Toast('昵称有非法字符，请换一个吧~');
                return false;
            }
            this.updateMemberAccount();
        },
        changeName() {
            this.nameShow = true;
        },
        // 请求详情存入local
        queryMemberAccountDetail() {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/account/queryMemberAccountDetail',
                    params: {
                        merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.formatiDetailInfo(data);
                }
            );
        },
        logout() {
            const ths = this;
            confirmModal('确定要退出登录吗？', function() {
                ths.$doRequest(
                    {
                        url: '/user/logout',
                        params: {

                        },
                        complete: function() {}
                    },
                    function(data) {
                        ths.ESVStorage.removeSavedValue('accountDetail');
                        ths.ESVStorage.removeSavedValue('accountNo');
                        ths.ESVStorage.removeSavedValue('channel');
                        ths.esvOpenPage('OPLogin');
                    }
                );
            });
        },
        // 修改接口
        updateMemberAccount() {
            const ths = this;
            const { mobileNumber, accountNickName, birthday, sex, accountAvatar } = ths.accoutDetail;

            ths.$doRequest(
                {
                    url: '/account/updateMemberAccount',
                    params: {
                        mobileNumber,
                        accountNickName,
                        birthday,
                        sex,
                        accountAvatar

                    },
                    complete: function() {}
                },
                function(data) {
                    ths.formatiDetailInfo(data);
                }
            );
        },
        // 绑定cis会员信息
        bindCisMemberAccount() {
            const { cisAccId, cisEntityName } = this.accoutDetail;

            this.$doRequest(
                {
                    url: '/account/bindCisMemberAccount',
                    params: {
                        cisAccId: cisAccId.trim(),
                        cisEntityName: cisEntityName.trim(),
                        merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                    },
                    complete: function() {}
                },
                (data) => {
                    // 00成功
                    // 10客户编号不存在
                    // 11客户名称不存在
                    // 12客户编号与名称不匹配
                    // 99异常错误
                    if (data.result === '10' || data.result === '11' || data.result === '12') {
                        this.$toast('客户编号与名称不匹配');
                    } else if (data.result === '00') {
                        this.$toast('绑定成功');
                        this.backBtn();
                    } else {
                        this.$toast('异常错误');
                    }
                    // this.accoutDetail = cisAccId ? cisAccId + '|' + cisEntityName : '';
                }
            );
        },
        addPhoto: function() {
            console.log(this.ESVImage.choose);
            const self = this;
            self.ESVImage.choose(
                {
                    count: 1,
                    origin: ['camera', 'album']
                },
                (imgs) => {
                    imgs.forEach(img => {
                        self.ESVImage.upload(img, img => {
                            self.accoutDetail.accountAvatar = img.photoUrl;
                            self.updateMemberAccount();
                        });
                    });
                }
            );
        },
        // 格式化详情信息
        formatiDetailInfo(resultData) {
            const ths = this;
            const { cisAccId, cisEntityName, accountAvatar } = resultData.result;
            ths.headImageUrl = accountAvatar || require('../assets/img/myCenter/defaultImg.png');

            if (ths.nameShow) {
                ths.nameShow = false;
            }
            const accountBind = cisAccId ? cisAccId + '|' + cisEntityName : '';
            ths.accoutDetail = { ...ths.emptyDetail, ...resultData.result, accountBind };

            if (ths.accoutDetail.birthday) {
                ths.currentDate = new Date(ths.accoutDetail.birthday);
            }

            if (ths.accoutDetail.sex) {
                ths.checkedSexIndex = ths.sexColumns.indexOf(ths.accoutDetail.sex);
            } else {
                ths.checkedSexIndex = -1;
            }
        },
        chooseDate() {
            if (this.sexShow === true) {
                this.sexShow = false;
            }
            this.dateShow = true;
        },
        // 取消日期按钮
        cancelDate() {
            const ths = this;
            ths.dateShow = false;

            if (ths.accoutDetail.birthday) {
                ths.currentDate = ths.accoutDetail.birthday ? new Date(ths.accoutDetail.birthday) : new Date();
            }
            if (this.accoutDetail.birthday) {
                this.currentDate = new Date(this.accoutDetail.birthday);
            }
        },
        // 确定日期按钮
        confirmDate(date) {
            this.accoutDetail.birthday = this.$moment(date).format('YYYY-MM-DD');
            this.dateShow = false;
            this.updateMemberAccount();
        },
        chooseSex() {
            if (this.dateShow === true) {
                this.dateShow = false;
            }
            this.sexShow = true;
        },
        confirmSex(sex) {
            this.accoutDetail.sex = sex;
            this.sexShow = false;
            this.updateMemberAccount();
        },
        cancelSex() {
            const ths = this;
            this.sexShow = false;

            const defaultCheckedIndex = this.checkedSexIndex !== -1 ? this.checkedSexIndex : 0;
            this.$refs.sexPicker.setColumnValue(0, ths.sexColumns[defaultCheckedIndex]);
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch',
            'merchantInfo'
        ])
    }
};
</script>
<style lang="scss" scoped>
.buttonStyle {
    position: fixed;
    bottom: 0;
    width: 100%;
    .van-button {
        width: 100%;
        background: #ee2e50;
        color: #fff;
        height: 50px;
    }
}

.mt12 {
    margin-top: 12px;
}
.bgwhite {
    background: #fff;
}
.infoClass {
    width: 100%;
    height: 100%;
}
.headImageSetting {
    .van-cell__title {
        line-height: 74px;
    }
    .van-cell__right-icon {
        line-height: 74px;
    }
    img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
    }
    .addphoto {
        background: #fff;
        align-items: normal;
    }
}
.headerBox {
    margin-top: 3px;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    float: right;
}
.nameShowStyle {
    width: 100%;
    height: 100%;
    background: #f2f3f3;
    .nameBox {
        width: 100%;
        text-align: center;
        .btnOk {
            width: 92%;
            background: #ee2e50;
            color: #fff;
            margin-top: 17px;
        }
        .btnCancel {
            width: 92%;
            margin-top: 10px;
        }
    }
}
</style>
